import Axios from '@/utils/http'
// 查看个人信息
export function detailUserInfo(data) {
    return Axios.getCom(window.Glod["ccex-api-svc"] + '/api/user/getUserInfo', data)
}